@if (showCombined && color) {
  <div class="color-list">
    <div class="desc">
      {{ color.Description | dataTranslate | translate }}
    </div>
    <div>
      {{ color.Code }}
    </div>
  </div>
}
@if (!showCombined && color) {
  <span>
    {{ color.Description | dataTranslate | translate }}
  </span>
}